import type { Page } from '@efdigital/ll-addon-data';
import { findPageWithContent } from '@efdigital/ll-admin-v2/data/builders/content/pages.ts';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ParamsPageId = {
  page_id: string;
};

export type ProgramsProgramCohortContentPageModel = ProgramsProgramCohortModel &
  ParamsPageId & {
    page: Page;
  };

export default class ProgramsProgramCohortContentPageRoute extends Route<ProgramsProgramCohortContentPageModel> {
  @service declare store: Store;

  async model(params: ParamsPageId) {
    const page = await this.store.request(findPageWithContent(params.page_id));
    return {
      ...(this.modelFor(
        'programs.program.cohort.content'
      ) as ProgramsProgramCohortModel),
      ...params,
      page: page.content.data,
    };
  }
}
